import * as olStyle from 'ol/style';
import { getVuetifyThemeVar } from '@/utils/mapLayerTheme';
import { withOpacity } from '@/utils/map/olColor';

const getThemeVar = getVuetifyThemeVar;

/**
 * geometry 타입 문자열 → 기본 스타일 (레거시 draw/디버그 등)
 */
export const geometryTypeStyles = {
  Point: new olStyle.Style({
    image: new olStyle.Circle({
      radius: 5,
      fill: new olStyle.Fill({
        color: getThemeVar('--v-error-base', '#C62828')
      })
    })
  }),
  LineString: new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: getThemeVar('--v-success-base', '#2E7D32'),
      width: 10
    })
  }),
  MultiLineString: new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: getThemeVar('--v-success-base', '#2E7D32'),
      width: 1
    })
  }),
  MultiPoint: new olStyle.Style({
    image: new olStyle.Circle({
      radius: 5,
      fill: null,
      stroke: new olStyle.Stroke({
        color: getThemeVar('--v-error-base', '#C62828'),
        width: 1
      })
    })
  }),
  MultiPolygon: new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: getThemeVar('--v-warning-base', '#E65100'),
      width: 1
    }),
    fill: new olStyle.Fill({
      color: withOpacity(getThemeVar('--v-warning-base', '#E65100'), 0.1)
    })
  }),
  Polygon: new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: withOpacity(getThemeVar('--v-info-base', '#1565C0'), 0.2),
      width: 1
    }),
    fill: new olStyle.Fill({
      color: withOpacity(getThemeVar('--v-info-base', '#1565C0'), 0.1)
    })
  }),
  GeometryCollection: new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: getThemeVar('--v-accent-base', 'magenta'),
      width: 2
    }),
    fill: new olStyle.Fill({
      color: getThemeVar('--v-accent-base', 'magenta')
    }),
    image: new olStyle.Circle({
      radius: 10,
      fill: null,
      stroke: new olStyle.Stroke({
        color: getThemeVar('--v-accent-base', 'magenta')
      })
    })
  }),
  Circle: new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: getThemeVar('--v-error-base', '#C62828'),
      width: 2
    }),
    fill: new olStyle.Fill({
      color: withOpacity(getThemeVar('--v-error-base', '#C62828'), 0.2)
    })
  })
};
